import { useRouter } from "next/router";
import { useEffect } from "react";
import { createBoundBehaviorSubject } from "util/rx/bound-subject";
import Head from "next/head";

const ReferralRegistrationPage = () => {
  const { push } = createBoundBehaviorSubject("", "referral");
  const router = useRouter();

  useEffect(() => {
    if (!router.query.referral) return;
    push(router.query.referral);
    router.push("/camelot");
  }, [push, router]);

  return (
    <>
      <Head>
        <title>Marginly - Trading contest</title>
      </Head>
    </>
  );
};

export default ReferralRegistrationPage;
